// Twilio A2P 10DLC compliance — single source of truth for the
// business identity displayed across every public page, contact page,
// footer, privacy / terms / SMS program copy, and registration consent.
//
// Values are matched EXACTLY against the Twilio Brand registration
// (Brand SID BN7324108c…). Changes here propagate to every page that
// imports BUSINESS_IDENTITY — never hard-code these values elsewhere.

export const BUSINESS_IDENTITY = {
  legalName: "RUDRAS COMMERCIALS",
  tradeName: "Rudras-AI",
  // Single-line address used in the footer; multi-line variant below.
  addressOneLine: "3806 Tammony Park Lane, Friendswood, TX 77546, USA",
  addressLines: [
    "3806 Tammony Park Lane",
    "Friendswood, TX 77546",
    "United States",
  ],
  phoneDisplay: "+1 (408) 823-1402",
  phoneE164: "+14088231402",
  supportEmail: "support@rudras-ai.com",
  websiteUrl: "https://rudras-ai.com",
};

// SMS consent text — version-pinned so we can prove (in a Twilio audit)
// the exact wording a given user agreed to. When the wording changes,
// bump `SMS_CONSENT_TEXT_VERSION` and add a new entry.
export const SMS_CONSENT_TEXT_VERSION = "v3-2026-02";
export const SMS_CONSENT_TEXT =
  "I agree to receive SMS messages from Rudras-AI regarding account verification, " +
  "service notifications, customer support updates, order confirmations, " +
  "and order status updates. Message frequency varies. Message and data rates may apply. " +
  "Reply STOP to opt out. Reply HELP for assistance. " +
  "Consent is not a condition of purchase or use of Rudras-AI services. " +
  "View our Privacy Policy, Terms & Conditions, and SMS Program.";

// Helper used by registration / OTP flows when persisting consent.
// Captures the exact source URL so a future audit can reconstruct
// which page the consent originated from.
//
// Twilio resubmission (Feb 2026, second pass) — the envelope is now
// ALWAYS returned regardless of `granted`. The backend uses this to
// keep an audit row even when the customer declined SMS, so the
// "did this user opt in?" answer is provably stored — not inferred.
export function buildSmsConsentPayload(opts = {}) {
  const granted = opts.granted === true;
  let sourceUrl = "";
  let userAgent = "";
  try { sourceUrl = window.location.href; } catch (_e) { /* SSR safe */ }
  try { userAgent = (navigator && navigator.userAgent) || ""; } catch (_e) { /* SSR safe */ }
  const base = {
    sms_consent: granted,
    sms_consent_at: new Date().toISOString(),
    sms_consent_source: opts.source || "registration",
    sms_consent_source_url: sourceUrl,
    sms_consent_text_version: SMS_CONSENT_TEXT_VERSION,
    sms_consent_user_agent: userAgent,
  };
  // Only include the displayed consent text when the customer actually
  // checked the box — for unchecked rows there is nothing to attest.
  if (granted) {
    base.sms_consent_text = SMS_CONSENT_TEXT;
  }
  return base;
}
